import { render, staticRenderFns } from "./Calciatore.vue?vue&type=template&id=7ae7fcff&scoped=true&"
import script from "./Calciatore.vue?vue&type=script&lang=js&"
export * from "./Calciatore.vue?vue&type=script&lang=js&"
import style0 from "./Calciatore.vue?vue&type=style&index=0&id=7ae7fcff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae7fcff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae7fcff')) {
      api.createRecord('7ae7fcff', component.options)
    } else {
      api.reload('7ae7fcff', component.options)
    }
    module.hot.accept("./Calciatore.vue?vue&type=template&id=7ae7fcff&scoped=true&", function () {
      api.rerender('7ae7fcff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Calciatore.vue"
export default component.exports